import { z } from 'zod'

/** Represents the enum public.webhook_event_status_ */
enum WebhookEventStatus {
  pending = 'pending',
  processing = 'processing',
  completed = 'completed',
  failed = 'failed',
  skipped = 'skipped',
}

export default WebhookEventStatus

/** Zod schema for webhook_event_status_ */
export const webhookEventStatus = z.enum([
  'pending',
  'processing',
  'completed',
  'failed',
  'skipped',
])
